import type { SVGProps } from "react";

export const TransactionsEmptyState = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="514"
      height="386"
      fill="none"
      viewBox="0 0 514 386"
      {...props}
    >
      <path
        fill="#F3F3F3"
        d="m423.357 67.198 5.107 31.005c4.567 27.73 26.302 49.464 54.032 54.032l31.004 5.107-31.004 5.107c-27.73 4.567-49.465 26.302-54.032 54.032l-5.107 31.005-5.107-31.005c-4.568-27.73-26.302-49.465-54.033-54.032l-31.004-5.107 31.004-5.107c27.731-4.568 49.465-26.302 54.033-54.033zM361.076 0l1.578 9.583a20.26 20.26 0 0 0 16.701 16.701l9.583 1.579-9.583 1.578a20.26 20.26 0 0 0-16.701 16.701l-1.578 9.583-1.579-9.583a20.26 20.26 0 0 0-16.701-16.7l-9.583-1.58 9.583-1.578a20.26 20.26 0 0 0 16.701-16.7zM28.363 101.617l1.578 9.583a20.26 20.26 0 0 0 16.701 16.701l9.583 1.578-9.583 1.579a20.26 20.26 0 0 0-16.7 16.701l-1.58 9.583-1.578-9.583a20.26 20.26 0 0 0-16.7-16.701L.5 129.479l9.583-1.578A20.26 20.26 0 0 0 26.784 111.2zM102.937 237.652l1.261 34.107c.771 20.867 17.475 37.601 38.292 38.364l35.02 1.283-35.02 1.283c-20.817.763-37.521 17.497-38.292 38.364l-1.261 34.107-1.261-34.107c-.772-20.867-17.475-37.601-38.293-38.364l-35.02-1.283 35.02-1.283c20.818-.763 37.521-17.497 38.293-38.364z"
      ></path>
      <path
        fill="#333"
        stroke="#2F7DC8"
        strokeWidth="13.112"
        d="m209.928 142.695-5.227-5.227-4.565 5.814c-9.564 12.18-15.249 27.527-15.249 44.204 0 39.842 32.272 72.115 72.115 72.115 16.676 0 32.024-5.686 44.203-15.249l5.814-4.565-5.227-5.227zm94.148 89.581 5.227 5.227 4.565-5.814c9.563-12.179 15.249-27.527 15.249-44.203 0-39.842-32.273-72.115-72.115-72.115-16.677 0-32.024 5.685-44.204 15.249l-5.814 4.565 5.227 5.227zm-122.467-44.79c0-41.615 33.778-75.393 75.393-75.393s75.393 33.778 75.393 75.393-33.778 75.393-75.393 75.393-75.393-33.778-75.393-75.393Z"
      ></path>
    </svg>
  );
};
